import barba from '@barba/core';
import viewsArray from './viewsArray';
import transitionsArray from './transitionsArray';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

let firstLoad = true;

export default class Spa {
	constructor() {
		barba.hooks.beforeOnce(({ current, next, trigger }) => {
			console.log('once', current);
		});

		barba.hooks.before(({ current, next, trigger }) => {
			// console.log('1 before');
		});

		barba.hooks.beforeLeave(({ current, next, trigger }) => {
			//console.log('2 beforeLeave');
		});

		barba.hooks.leave(({ current, next, trigger }) => {
			// This should be here even when empty..
			//console.log('3 leave');

			const leaveEvent = new Event('leave', {
				bubbles: true,
			});

			document.dispatchEvent(leaveEvent);
		});

		barba.hooks.afterLeave(({ current, next, trigger }) => {
			//console.log('4 afterLeave');
		});

		barba.hooks.beforeEnter(({ current, next, trigger }) => {
			// console.log('5 beforeEnter');

			if (firstLoad) {
				firstLoad = false;

				if (next.namespace == 'template-homepage') {
					window.menuInteractive = false;
				} else {
					window.menuInteractive = true;
				}
			}

			if (history.scrollRestoration) {
				history.scrollRestoration = 'manual';
			}

			const triggers = ScrollTrigger.getAll();
			triggers.forEach((trigger) => {
				trigger.kill();

				// Aww merr gawd.. 1 volle labs dag verder.
				// Shame.. na een dag zoeken is dit de beste oplossing. Wellicht eens kijken of dit weg kan als er een nieuwe versie van gsap/scrollTrigger is
				trigger.scroll.rec = null;
				const lelijk = setInterval(() => {
					if (trigger.scroll.rec !== null) {
						trigger.scroll.rec = null;
					}
				}, 10);
			});

			const blessEvent = new CustomEvent('bless', {
				bubbles: true,
				detail: {
					current: current,
					next: next,
					trigger: trigger,
				},
			});

			// Set body classes based on the namespace of the next view
			if (next.namespace == 'template-caregivers-hub' || next.namespace == 'template-subject-term-single') {
				document.body.classList.add('caregivers-hub');
			} else {
				document.body.classList.remove('caregivers-hub');
			}

			next.container.dispatchEvent(blessEvent);
		});

		barba.hooks.enter(({ current, next, trigger }) => {
			//console.log('6 enter');
		});

		barba.hooks.afterEnter(({ current, next, trigger }) => {
			if (location.hash) {
				gsap.to(window, {
					duration: 2,
					scrollTo: location.hash,
					ease: 'power3.inOut',
				});
			}
		});

		barba.hooks.after(({ current, next, trigger }) => {
			var parser = new DOMParser();
			var htmlDoc = parser.parseFromString(next.html, 'text/html');
			const scripts = htmlDoc.getElementsByTagName('script');

			function evalInWindow(src) {
				const func = function () {
					eval(src);
				};

				//define event to prevent errors in gform javascript
				const backup = window.event;
				window.event = {};
				func.call(window);
				delete window.event;

				if (backup !== undefined) {
					window.event = backup;
				}else{
					window.event = {
						preventDefault() {}
					};
				}
			}

			[...scripts].forEach((script) => {
				if (script.hasAttribute('data-barba-include')) {
					let src = script.innerHTML;
					try {
						// console.log({ src });
						evalInWindow(src);
					} catch (e) {
						console.error(e);
					}
				}
			});
		});

		// Barba settings, transitions and views
		barba.init({
			debug: window.WPDATA.env == 'development' ? true : false,
			timeout: 5000,
			requestError: (trigger, action, url, response) => {
				if ((trigger === 'back' || trigger === 'forward') && response.status && response.status === 404) {
					return true;
				}

				return false;
			},
			prevent: ({ el, event, href }) => {
				if (/\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(href)) {
					return true;
				}
			},
			views: viewsArray,
			transitions: transitionsArray,
		});
	}
}
